import { render, staticRenderFns } from "./ContactContactTypeForm.vue?vue&type=template&id=f9905bbc&scoped=true&"
import script from "./ContactContactTypeForm.vue?vue&type=script&lang=js&"
export * from "./ContactContactTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactContactTypeForm.vue?vue&type=style&index=0&id=f9905bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9905bbc",
  null
  
)

export default component.exports